var _polygon, _polygon2, _path, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPracticalCases(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "167.1 140.72 120.09 140.72 120.09 230.91 230.32 230.91 230.32 120.69 167.1 120.69 167.1 140.72"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "143.91 173.43 134.12 183.22 161.78 210.88 216.66 156 206.86 146.21 161.78 191.29 143.91 173.43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.1,105.72V.57H27V140.72h78.18V245.87H245.28V105.72Zm-125.18,20V15.53H152.14V125.76Zm188.4,105.15H120.09V140.72h47v-20h63.22Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.6 86.14 65.73 68.27 55.94 78.06 83.6 105.72 138.48 50.85 128.69 41.05 83.6 86.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPracticalCases);
export default __webpack_public_path__ + "static/media/icon-practical-cases.8e5d7267.svg";
export { ForwardRef as ReactComponent };